import * as React from 'react'
import { compose, pure } from 'recompose'

import Icon, { IconType } from '../../atoms/Icon/Icon'
import TextLabel, { ColorType, SizeType, WeightType } from '../../atoms/TextLabel/TextLabel'
import * as styles from './Header.css'

interface HeaderProps {
  title: string
  participantCount?: number
}

const Header: React.FunctionComponent<HeaderProps> = ({ title, participantCount }) => {
  let participantCounter = null
  if (participantCount) {
    participantCounter = (
      <div className={styles.participantCount}>
        <Icon iconType={IconType.USER} />
        <TextLabel color={ColorType.ACCENT} size={SizeType.MEDIUM} weight={WeightType.NORMAL}>
          {participantCount}
        </TextLabel>
      </div>
    )
  }
  return (
    <div>
      <div className={styles.title}>
        <TextLabel color={ColorType.MODEST} size={SizeType.MEDIUM}>
          {title}
        </TextLabel>
      </div>
      {participantCounter}
    </div>
  )
}

export default compose<HeaderProps, HeaderProps>(pure)(Header)
